import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import styled from 'styled-components';
import * as Icons from '../Icons';
import Portal from './Portal';
const getColor = (variant) => {
    switch (variant) {
        case 'success':
            return 'background: #e3fcec; border: solid 1px #38c172; box-shadow: 0 4px 16px 0 #e3fcec; color: #38c172;';
        case 'error':
            return 'background: #fbe7e7; border: solid 1px #dc3030; box-shadow: 0 4px 16px 0 #fbe7e7; color: #dc3030;';
        case 'info':
            return 'background: #E8F4FB; border: solid 1px #1C92DD; box-shadow: 0 4px 16px 0 #E8F4FB; color: #1C92DD;';
        default:
            return 'background: #e3fcec; border: solid 1px #38c172; box-shadow: 0 4px 16px 0 #e3fcec; color: #38c172;';
    }
};
const Container = styled.div `
  padding: 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  min-width: 360px;
  justify-content: space-between;
  ${(props) => getColor(props.variant)};

  .icon-close {
    cursor: pointer;
    height: 24px;
  }
`;
const Text = styled.div `
  margin: 0 10px;
`;
const ActionText = styled.div `
  color: #152935;
  margin: 0 24px 0 44px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
function TransitionDown(props) {
    return React.createElement(Slide, Object.assign({}, props, { direction: "down" }));
}
const variantIcon = {
    success: () => React.createElement(Icons.IconCheckCircle, { color: "#38c172" }),
    error: () => React.createElement(Icons.IconWarning, { color: "#dc3030" }),
    info: () => React.createElement(Icons.IconInfo, { color: "#006dff" }),
};
const closeIcon = {
    success: () => React.createElement(Icons.IconClose, { color: "#38c172" }),
    error: () => React.createElement(Icons.IconClose, { color: "#dc3030" }),
    info: () => React.createElement(Icons.IconClose, { color: "#006dff" }),
};
const DirectionSnackbar = ({ open, handleClose, message, variant, autoHideDuration, showIcon, actionText, actionClick, }) => {
    const Icon = variantIcon[variant];
    const IconClose = closeIcon[variant];
    return (React.createElement(Portal, { className: "snackbar" },
        React.createElement(Snackbar, { anchorOrigin: { vertical: 'top', horizontal: 'center' }, open: open, onClose: handleClose, TransitionComponent: TransitionDown, autoHideDuration: autoHideDuration }, variant && (React.createElement(Container, { variant: variant },
            showIcon && React.createElement(Icon, null),
            React.createElement(Text, null, message),
            actionText && (React.createElement(ActionText, { onClick: actionClick }, actionText)),
            React.createElement("div", { onClick: handleClose, className: "icon-close" },
                React.createElement(IconClose, null)))))));
};
export default DirectionSnackbar;
